import { render, staticRenderFns } from "./TrustedIPs.vue?vue&type=template&id=32003606&scoped=true&"
import script from "./TrustedIPs.vue?vue&type=script&lang=js&"
export * from "./TrustedIPs.vue?vue&type=script&lang=js&"
import style0 from "./TrustedIPs.vue?vue&type=style&index=0&id=32003606&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32003606",
  null
  
)

export default component.exports